<script lang="ts">
    export let cssClass: string = ""
    export let hide: boolean = false
</script>

<div class="popover {cssClass}" class:hide>
    <slot name="trigger" />
    <div class="popover-content">
        <slot />
    </div>
</div>
